import {Component} from '@angular/core';
import {ApiService} from './../../services/api.service';

@Component({
  selector: 'my-home',
  template: require('./home.component.html'),
  styles: [require('./home.component.scss')]
})
export class HomeComponent {

  public listProductos = [];

  constructor(private _apiService: ApiService) {
    this._apiService.getAllProductos().subscribe(
      result => {
        this.listProductos = result;
      }
    );
  }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/home/home.component.ts